import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function SuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    toast.success("Payment successful!");

    // Optional: Redirect after a few seconds
    const timer = setTimeout(() => {
      navigate(-1);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="p-4">
      <h2 className="text-green-600 text-xl font-bold">Payment Successful!</h2>
      <p className="mt-2">Thank you for your payment. You’ll be redirected shortly.</p>
    </div>
  );
}
